import React, {useState}						from 'react';

import {SectionProps}							from './interface';

import Icon										from '../Icon';

import img_chevron								from '../../images/icon/chevron-down.svg';

import './Section.css';


function Section(props: SectionProps) {
	const [open, set_open] = useState('');

	return (
		<div className={`section ${props.sticky && 'sticky'}`} style={props.style}>
			{props.title &&
				<div
					className={'sectionTitle'}
					style={{
						...(open !== 'close' && {marginBottom: 8}),
						...(!props.canClose && {cursor: 'default'})
					}}
					onClick={() => props.canClose && set_open(open === 'close' ? 'open' : 'close')}
				>
					<div>
						<span className={'text-md weight-600 gray-700'}>{props.title}</span>
						{props.afterTitle}
					</div>
					{props.canClose && <Icon className={`anim-rotate-${open}`} icon={img_chevron} />}
				</div>
			}

			{(props.className && open !== 'close') &&
				<div className={props.className}>
					{props.children}
				</div>
			}

			{(!props.className && open !== 'close') && props.children}
		</div>
	);
}

export default Section;